import { Box, Card, Typography, colors } from "@mui/material";

const TermsOfService = () => {
  return (
    <Box
      bgcolor={colors.blue[600]}
      display="flex"
      flexDirection="column"
      alignItems="center"
      flexGrow={1}
      minHeight={"100vh"}
      p={10}
    >
      <Card sx={{ p: 5 }}>
        <Typography variant="h2"> TERMS OF SERVICE</Typography>
        <Typography variant="body1">
          {" "}
          Here are the terms of service. This is very much for personal use for
          benefit of Ayushi (Ayush) and the Chaudhary/Campbell joint family. Any
          and all other usage is subject to personal review and termination at
          any point by the owner of this site.
        </Typography>
      </Card>
    </Box>
  );
};

export default TermsOfService;
